import { render } from "./jkyStatistics.vue?vue&type=template&id=43baea24&scoped=true"
import script from "./jkyStatistics.vue?vue&type=script&lang=js"
export * from "./jkyStatistics.vue?vue&type=script&lang=js"

import "./jkyStatistics.vue?vue&type=style&index=0&id=43baea24&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43baea24"]])

export default __exports__